import { AlertItem } from '../../Services/serviceURL';

export const getAlertReasonLabel = (alert: AlertItem): string => {
  if (alert.reason) {
    return alert.reason;
  }

  if (alert.value >= alert.thresholdHH) {
    return 'High High';
  }
  if (alert.value >= alert.thresholdH && alert.value < alert.thresholdHH) {
    return 'High';
  }
  if (alert.value <= alert.thresholdLL) {
    return 'Low Low';
  }
  if (alert.value <= alert.thresholdL && alert.value > alert.thresholdLL) {
    return 'Low';
  }
  return 'N/A';
};

export const isCriticalOrDangerSeverity = (severityClass: string): boolean =>
  severityClass === 'danger' || severityClass === 'critical';
